import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import ProfileFilledSvg from "@ant-design/icons-svg/es/asn/ProfileFilled";
import AntdIcon from "../components/AntdIcon";
var ProfileFilled = function ProfileFilled(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: ProfileFilledSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  ProfileFilled.displayName = 'ProfileFilled';
}
export default /*#__PURE__*/React.forwardRef(ProfileFilled);